export default "__VITE_ASSET__aa708103__"